import { prismicSliceToAccordion } from 'prismic/slices/Accordion/AccordionSlice';
import { prismicSliceToCallToAction } from 'prismic/slices/CallToAction/CallToActionSlice';
import { prismicSliceToCountDown } from 'prismic/slices/CountDown/CountDownSlice';
import { prismicSliceToGoogleSheetTableSlice } from 'prismic/slices/GoogleSheetTable/GoogleSheetTableSlice';
import { prismicSliceToNumbers } from 'prismic/slices/Numbers/NumbersSlice';
import { prismicSliceToPrices } from 'prismic/slices/Prices/PricesSlice';
import { prismicSliceToQuote } from 'prismic/slices/Quote/QuoteSlice';
import { prismicSliceToStaffList } from 'prismic/slices/StaffList/StaffListSlice';
import { prismicSliceToText } from 'prismic/slices/Text/TextSlice';
import { prismicSliceToVideo } from 'prismic/slices/Video/VideoSlice';
import {
  NewsSlices,
  NewsSlicesAccordion,
  NewsSlicesCall_To_Action,
  NewsSlicesCount_Down,
  NewsSlicesGoogle_Sheet_Table,
  NewsSlicesNumbers,
  NewsSlicesPrices,
  NewsSlicesQuote,
  NewsSlicesStaff_List,
  NewsSlicesText,
  NewsSlicesVideo,
} from 'prismic-types';

import { ArticleSection } from 'components/article-section/ArticleSection';
import { Section } from 'components/section/Section';

type Props = {
  slices?: Array<NewsSlices>;
  date?: string;
};

export function NewsSlices({ slices = [], date }: Props) {
  return (
    <>
      {slices.map((s: NewsSlices, i: number) => {
        const key = `slice-${s.type}-${i}`;

        switch (s.type) {
          case 'quote':
            return (
              <ArticleSection key={key}>
                {prismicSliceToQuote(s as NewsSlicesQuote)}
              </ArticleSection>
            );
          case 'call_to_action':
            return (
              <Section key={key}>
                {prismicSliceToCallToAction(
                  s as NewsSlicesCall_To_Action,
                  i === 0 ? date : undefined
                )}
              </Section>
            );
          case 'numbers':
            return (
              <Section key={key}>
                {prismicSliceToNumbers(s as NewsSlicesNumbers)}
              </Section>
            );
          case 'google_sheet_table':
            return (
              <ArticleSection key={key}>
                {prismicSliceToGoogleSheetTableSlice(
                  s as NewsSlicesGoogle_Sheet_Table
                )}
              </ArticleSection>
            );
          case 'accordion':
            return (
              <ArticleSection key={key}>
                {prismicSliceToAccordion(s as NewsSlicesAccordion)}
              </ArticleSection>
            );
          case 'prices':
            return (
              <Section key={key}>
                {prismicSliceToPrices(s as NewsSlicesPrices)}
              </Section>
            );
          case 'count_down':
            return (
              <Section key={key} container>
                {prismicSliceToCountDown(s as NewsSlicesCount_Down)}
              </Section>
            );
          case 'staff_list':
            return (
              <Section key={key}>
                {prismicSliceToStaffList(s as NewsSlicesStaff_List)}
              </Section>
            );
          case 'text':
            return (
              <ArticleSection key={key}>
                {prismicSliceToText(
                  s as NewsSlicesText,
                  undefined,
                  i === 0 ? date : undefined
                )}
              </ArticleSection>
            );
          case 'video':
            return (
              <ArticleSection key={key}>
                {prismicSliceToVideo(s as NewsSlicesVideo)}
              </ArticleSection>
            );
          default:
            console.info(`NewsSlices: unknown slice type ${s.type}`, s);
            return process.env.NODE_ENV === 'production' ? null : (
              <Section key={key}>{`unknown slice type ${s.type}`}</Section>
            );
        }
      })}
    </>
  );
}
